import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { EnvironmentProviders, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { xsrfInterceptorIgnoredUrls, xsrfOptions } from 'src/environments/environment';

export type XsrfOptions = { headerName: string; cookieName: string };

function getCookie(name: string): string {
  return (
    document.cookie
      .split('; ')
      .find(row => row.startsWith(`${name}=`))
      ?.split('=')[1] ?? ''
  );
}

// Adapted from https://github.com/angular/angular/blob/main/packages/common/http/src/xsrf.ts (MIT)

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {
  public intercept(initialRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (initialRequest.method === 'GET' || initialRequest.method === 'HEAD' || xsrfInterceptorIgnoredUrls.some(url => initialRequest.url.includes(url))) {
      return next.handle(initialRequest);
    }
    const { headerName, cookieName } = xsrfOptions;

    const token: string = getCookie(cookieName);

    let request: HttpRequest<unknown> = initialRequest;

    if (token.length > 0 && !initialRequest.headers.has(headerName)) {
      request = initialRequest.clone({ headers: initialRequest.headers.set(headerName, token) });
    }

    return next.handle(request);
  }
}

export const XsrfInterceptorProvider: Provider | EnvironmentProviders = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpXsrfInterceptor,
  multi: true,
};
